const baseUrl = 'https://beeitech.com/backend/'
// const baseUrl = 'http://mplay.itechs.co.in/backend/'
export {baseUrl};


